// Client for the Worker leaderboard API (/api/score, /api/leaderboard) and the
// local prestige counter (Zero Day defeats). Same-origin fetch.
export interface ScoreEntry {
  name: string;
  zone: number;
  time: number;
  level: number;
  kills: number;
  fragments: number;
  ts?: number;
}

export interface ScorePayload {
  name: string;
  zone: number;
  time: number;
  level: number;
  kills: number;
  fragments: number;
}

/** Player handle, asked once and remembered locally. */
export function getName(): string {
  let n = "";
  try {
    n = localStorage.getItem("pckt_name") ?? "";
    if (!n) {
      n = (window.prompt("Enter your handle (max 16):", "PCKT") || "PCKT").slice(0, 16).trim() || "PCKT";
      localStorage.setItem("pckt_name", n);
    }
  } catch {
    n = "PCKT";
  }
  return n;
}

export function getPrestige(): number {
  try {
    return parseInt(localStorage.getItem("pckt_zeroday") ?? "0", 10) || 0;
  } catch {
    return 0;
  }
}

export function bumpPrestige(): void {
  try {
    localStorage.setItem("pckt_zeroday", String(getPrestige() + 1));
  } catch {
    /* ignore */
  }
}

/** Submit a score and return the updated top entries (falls back to a GET). */
export async function submitScore(payload: ScorePayload): Promise<ScoreEntry[]> {
  try {
    const res = await fetch("/api/score", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = (await res.json()) as { entries?: ScoreEntry[] };
    return data.entries ?? [];
  } catch {
    try {
      const r = await fetch("/api/leaderboard?limit=10");
      const d = (await r.json()) as { entries?: ScoreEntry[] };
      return d.entries ?? [];
    } catch {
      return [];
    }
  }
}
